import { EventEmitter } from 'eventemitter3'

import { AuthStore } from '../store/interface'

const LOGIN_EVENT = 'login'

const authEvent = new EventEmitter()

/**
 * 触发登录事件
 */
export const emitLoginEvent = (store: AuthStore) => {
  authEvent.emit(LOGIN_EVENT, store)
}

/**
 * 监听登录事件
 */
export const listenLoginEvent = (callback: (store: AuthStore) => void) => {
  authEvent.on(LOGIN_EVENT, callback)
}
